export default __webpack_public_path__ + "static/media/impact.ef161569.png";